import declare from "dojo/_base/declare";
import api from "csi/api";
import Widget from "csi/form/Widget";
import html from "csi/html";
import sessionConstants from "csi/sessionConstants";
import xml from "csi/xml";

const CANVAS_NOTES_ORIENTATION = "CanvasNotesOrientation";
const NOTES_ORIENTATION = "NotesOrientation";
const PAPER_ORIENTATION = "PaperOrientation";
const PAPER_SIZE = "PaperSize";

const ProductPresentationLayoutForm = declare(Widget, {
	/*
	* @override
	* Block changing paper size and orientation on copy, also have them adjust each other
	*/
	_resolveView() {
		this.inherited(arguments);

		const sitePaperSize = sessionConstants.sitePaperSize;
		const sitePaperOrientation = sessionConstants.sitePaperOrientation;
		const notesOrientation = (sitePaperOrientation === api.LANDSCAPE) ? html.LEFT : html.TOP;

		this.addDefaultValue(PAPER_SIZE, xml.enumCreate(PAPER_SIZE, sitePaperSize));
		this.addDefaultValue(PAPER_ORIENTATION, xml.enumCreate(PAPER_ORIENTATION, sitePaperOrientation));
		this.addDefaultValue(NOTES_ORIENTATION, xml.enumCreate(CANVAS_NOTES_ORIENTATION, notesOrientation));
		
		if (this.isCopy()) {
			this.setFieldDisabled(PAPER_SIZE, true);
			this.setFieldDisabled(PAPER_ORIENTATION, true);
			this.setFieldDisabled(NOTES_ORIENTATION, true);
		}
	},

	/**
	 * @override
	 * Set the notes orientation based on the page orientation.
	 */
	onChangeField(field) {
		this.inherited(arguments);

		if (field.getControlName() == PAPER_ORIENTATION && this.getField(NOTES_ORIENTATION).isDefaultValue()) {
			var paperOrientation = xml.enumGetText(field.getValue());
			var notesOrientation = (paperOrientation === api.LANDSCAPE) ? html.LEFT : html.TOP;
			this.setFieldValue(NOTES_ORIENTATION, xml.enumCreate(CANVAS_NOTES_ORIENTATION, notesOrientation));
		}
	},
});

export = ProductPresentationLayoutForm;